module.exports = __webpack_public_path__ + "media/images/guide-thumb-1-8ab27b8e29d0c9719636e14d0d438b14.png";